import {Component,inject } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { CrmService } from '../../../../services/api/crm.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../../services/notify/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, Observable, Subscription } from 'rxjs';
import { TFormState } from '../../../../models/forms.model';
import { Router } from '@angular/router';
import { TaskOptionsService } from '../../../../services/task-options.service';
import { TaskBoardModel } from '../../../../models/tasktable.model';

@Component({
    selector: 'app-task-mngt-form',
    templateUrl: './task-mngt-form.html',
    styleUrl: './task-mngt-form.scss'
})
export class AppTaskMngtFormComponent {
    private subs = new Subscription
	public mngtTaskForm: FormGroup|undefined = undefined
	public formState:TFormState = 'Default'
    public boards:TaskBoardModel[]|undefined = undefined
    private dialogRef = inject(MatDialogRef<AppTaskMngtFormComponent>,{optional:true})
	constructor(
		private router: Router,
		private crmService: CrmService,
		private alertService: AlertService,
		private translateService: TranslateService,
        private taskOptionsService: TaskOptionsService,
		private fb: FormBuilder,
	) {}
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
	ngOnInit(): void {
		this.mngtTaskForm = this.fb.group({
			title:[null, {validators: [Validators.required]}],
			content:[null],
			boardData:[null, {validators: [Validators.required]}],
			task_type:[null],
		})
        if (this.boards?.length===1) { // boardAlias has been preset
            this.boardData?.patchValue(this.boards[0]);
            this.task_type?.patchValue(this.boards[0].task_types[0]);
        }
	}
    createTask() {
        this.formState = 'Submitting';
        let taskData = {
            ... this.mngtTaskForm?.value,
            board_alias: this.boardData?.value.alias,
            task_type_id: this.task_type?.value.id,
        };
        this.crmService.createTask(taskData)
        .pipe(catchError(err=>this.errorHandler(err)))
        .subscribe( res => {
            this.formState = 'Default';
            this.dialogRef?.close(res.task)
            this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
        }); 
    }
    errorHandler(error:{message:string},showErrMsg = true):Observable<never> {
		this.formState = 'Default';
		showErrMsg? this.alertService.setAlert(error.message, 'blue') : null;
		return EMPTY
	}
    get title() {return this.mngtTaskForm?.get('title')}
    get content() {return this.mngtTaskForm?.get('content')}
    get boardData() {return this.mngtTaskForm?.get('boardData')}
    get task_type() {return this.mngtTaskForm?.get('task_type')}
}